import { render, staticRenderFns } from "./adminNew.vue?vue&type=template&id=0b057a3e&scoped=true&"
import script from "./adminNew.vue?vue&type=script&lang=ts&"
export * from "./adminNew.vue?vue&type=script&lang=ts&"
import style0 from "./adminNew.vue?vue&type=style&index=0&id=0b057a3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b057a3e",
  null
  
)

export default component.exports